/** Production widget host (internalalias → ba.hse.ru embed). */
export const WIDGET_HOST = 'https://internalalias1b.deqstudio.com/public/HSEAdmWidgets';

/** Widget JS/CSS — embed `<script>` and `<link>`. */
export const WIDGET_LIB = `${WIDGET_HOST}/lib`;

/** Data files — xlsx, csv; pass as `storageUri` to mountWidget(). */
export const WIDGET_APP = `${WIDGET_HOST}/app`;

export const CDN_STORAGE_URI = WIDGET_APP;
export const CDN_WIDGET_JS = `${WIDGET_LIB}/hse-adm-widget.umd.js`;
export const CDN_WIDGET_CSS = `${WIDGET_LIB}/style.css`;
export const CDN_FONT_HSE_SANS = 'https://hse.ru/f/src/global/fonts/HSESans-Regular.woff2';

/** Same-origin path in dev; full production URL otherwise. */
export function getStorageUri(): string {
  if (import.meta.env.DEV) {
    return '/app';
  }
  return CDN_STORAGE_URI;
}
